import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { Image } from '@qga/roo-ui/components';
import getAsset from '@/utils/getAsset';
import PropertyContent from '@/propTypes/PropertyContent';
import markerSelected from '../../assets/ic_place_blue.svg';
import marker from '../../assets/ic_place_orange.svg';

const Pin = styled(Image)`
  height: 24px;
  position: absolute;
  left: -12px;
  top: -24px;
  &:hover {
    filter: brightness(90%);
  }
`;

const Label = ({ isSelected, property }) => (
  <Pin
    src={getAsset(isSelected ? markerSelected : marker)}
    alt={property.name}
  />
);

Label.defaultProps = {
  isSelected: false,
};

Label.propTypes = {
  isSelected: PropTypes.bool,
  property: PropTypes.shape(PropertyContent).isRequired,
};

export default Label;
